import React from 'react';

const Privacy = () => (
  <div className="max-w-3xl mx-auto px-4 py-16 text-text-primary">
    <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
    <p className="mb-4">At AtlasMoth, we value your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our website.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">Information We Collect</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Email addresses you provide when subscribing to our newsletter or contacting us.</li>
      <li>Usage data collected via cookies and analytics tools to improve your experience.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">How We Use Information</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>To send you newsletters, updates, and relevant content (only if you opt in).</li>
      <li>To improve our website and services based on aggregated usage data.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">Your Rights</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>You can unsubscribe from our newsletter at any time using the link in our emails.</li>
      <li>You may request to access, update, or delete your personal data by contacting us at <a href="mailto:kbaid@atlasmoth.com" className="underline">kbaid@atlasmoth.com</a>.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">Third-Party Services</h2>
    <p className="mb-4">We use trusted third-party services (such as Beehiiv for newsletters and analytics providers) that may collect data as described in their own privacy policies.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">Contact</h2>
    <p>If you have any questions about this policy, please email us at <a href="mailto:kbaid@atlasmoth.com" className="underline">kbaid@atlasmoth.com</a>.</p>
    <p className="mt-8 text-xs text-text-secondary">Last updated: June 15, 2025</p>
  </div>
);

export default Privacy;
